import { j as a } from "../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.mjs";
const A = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M144,128a16,16,0,1,1-16-16A16,16,0,0,1,144,128ZM60,112a16,16,0,1,0,16,16A16,16,0,0,0,60,112Zm136,0a16,16,0,1,0,16,16A16,16,0,0,0,196,112Z" }) })
  ],
  [
    "duotone",
    /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(
        "path",
        {
          d: "M240,96v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80H224A16,16,0,0,1,240,96Z",
          opacity: "0.2"
        }
      ),
      /* @__PURE__ */ a.jsx("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" })
    ] })
  ],
  [
    "fill",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M224,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V96A16,16,0,0,0,224,80ZM60,140a12,12,0,1,1,12-12A12,12,0,0,1,60,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm68,0a12,12,0,1,1,12-12A12,12,0,0,1,196,140Z" }) })
  ],
  [
    "light",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M138,128a10,10,0,1,1-10-10A10,10,0,0,1,138,128ZM60,118a10,10,0,1,0,10,10A10,10,0,0,0,60,118Zm136,0a10,10,0,1,0,10,10A10,10,0,0,0,196,118Z" }) })
  ],
  [
    "regular",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z" }) })
  ],
  [
    "thin",
    /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsx("path", { d: "M136,128a8,8,0,1,1-8-8A8,8,0,0,1,136,128Zm-76-8a8,8,0,1,0,8,8A8,8,0,0,0,60,120Zm136,0a8,8,0,1,0,8,8A8,8,0,0,0,196,120Z" }) })
  ]
]);
export {
  A as default
};
